<section class="safetytrainingrow">
    <div class="container">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="white_fonts">
                    <div class="row animate__animated animate__fadeInUp top">
                        <div class="col-sm-2"></div>
                        <div class="col-sm-8">
                            <header class="section-header">
                                <h3>Live Trainings</h3>
                            </header>
                        </div>
                        <div class="col-sm-2"></div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>

<section>
    <div class="container">
        <div class="row">
            <div class="col-lg-8" data-aos="fade-right" data-aos-delay="300">

                <div class="row">
                    <div class="col-lg-12">
                        <h3 class="theme_color">
                            <strong>Through Training</strong> you give your employees the knowledge and tools to work safely.
                        </h3>

                        <p class="theme_color fontSize">
                            SFI Safety provides practical training designed to support regulatory requirements,
                             strengthen safe work practices, and create lasting knowledge in the field. 
                             Our training is <strong>Built on Excellence,</strong>with qualified and authorized instructors 
                             delivering courses 
                             you can trust in both English and Spanish.
                        </p>
                        <br>
                        <p class="theme_color fontSize">
                            We stand behind the training we provide. If applicable regulations change within one 
                            year of the class date, we will provide updated information and, 
                            when necessary, help ensure required recertification is addressed.
                        </p>
                        <p><strong>Take your team Beyond Compliance with training Built on Excellence.</strong></p>
                        <p><strong>Ready to join us? Click on a scheduled training or meeting below to sign in and join the live event now.</strong></p>
                        <h3 class="theme_color">
                            <strong>Live Events</strong>&nbsp;&nbsp;
                            <button type="button" (click)="getData()" class="btn btn-outline-primary btn-sm">Click to
                                refresh Trainings/Meetings</button>
                        </h3>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12">
                        <ul class="nav nav-tabs" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                              <a class="nav-link active tab-name" id="trainings-tab" data-toggle="tab" href="#trainings" role="tab" aria-controls="trainings" aria-selected="true">Trainings</a>
                            </li>
                            <li class="nav-item" role="presentation">
                              <a class="nav-link tab-name" id="meetings-tab" data-toggle="tab" href="#meetings" role="tab" aria-controls="meetings" aria-selected="false">Meetings</a>
                            </li>
                            
                          </ul>
                          <div class="tab-content" id="myTabContent">
                            <div class="tab-pane fade show active" id="trainings" role="tabpanel" aria-labelledby="trainings-tab">
                                <div class="row" *ngFor="let sfiev of eventDetails"
                                    style="border-top: solid 1px gray;border-bottom: solid 1px gray;padding-top: 1%;padding-bottom: 1%;">
                                    <div class="col-sm-12 col-sm-4">
                                        <span
                                            class="maroonfont mediumFontSize"><strong>{{sfiev.coursename}}</strong></span><br />
                                        <span class="livevents_font"><b class="theme_color">Training Id</b> :
                                            <b>#{{sfiev.id}}</b></span><br />
                                        <span class="livevents_font"><b class="theme_color">On</b> :
                                            {{sfiev.datetime}}</span><br />
                                        <span class="livevents_font"><b class="theme_color">Instructor</b> :
                                            {{sfiev.instructor}}</span><br />
                                        <div class="livelink">
                                            <a class="maroonfont" (click)="goToDetailsPage(sfiev.link)"><u><strong>Sign
                                                        In</strong></u></a>
                                        </div>

                                    </div>
                                </div>

                                <div class="row" *ngIf="eventDetails.length===0"
                                    style="border-top: solid 1px gray;border-bottom: solid 1px gray;padding-top: 1%;padding-bottom: 1%;">
                                    <div class="col-sm-12 col-sm-12">
                                        <span class="maroonfont mediumFontSize">We're sorry but there are no live events right now, please try again later. If you would like to see a list of our upcoming events, please click <a href="/safetytraining"
                                            [routerLink]="['/safetytraining']">here</a></span>
                                    </div>
                                </div>

                            </div>
                            <div class="tab-pane fade" id="meetings" role="tabpanel" aria-labelledby="meetings-tab">
                                <div class="row" *ngFor="let sfiev of meetingDetails"
                                    style="border-top: solid 1px gray;border-bottom: solid 1px gray;padding-top: 1%;padding-bottom: 1%;">
                                    <div class="col-sm-12 col-sm-4">
                                        <span
                                            class="maroonfont mediumFontSize"><strong>{{sfiev.coursename}}</strong></span><br />
                                            <span class="livevents_font"><b class="theme_color">Meeting Id</b> :
                                                <b>#{{sfiev.id}}</b></span><br />
                                        <span class="livevents_font"><b class="theme_color">On</b> :
                                            {{sfiev.datetime}}</span><br />
                                        <span class="livevents_font"><b class="theme_color">Instructor</b> :
                                            {{sfiev.instructor}}</span><br />
                                        <div class="livelink">
                                            <a class="maroonfont" (click)="goToMeetingsPage(sfiev.link)"><u><strong>Sign
                                                        In</strong></u></a>
                                        </div>

                                    </div>
                                </div>

                                <div class="row" *ngIf="meetingDetails.length===0"
                                    style="border-top: solid 1px gray;border-bottom: solid 1px gray;padding-top: 1%;padding-bottom: 1%;">
                                    <div class="col-sm-12 col-sm-12">
                                        <span class="maroonfont mediumFontSize">We're sorry but there are no live events right now, please try again later. If you would like to see a list of our upcoming events, please click <a href="/safetytraining"
                                            [routerLink]="['/safetytraining']">here</a></span>
                                    </div>
                                </div>
                            </div>
                            
                          </div>
                    </div>
                </div>

            </div>
            <div class="col-lg-4" data-aos="fade-left" data-aos-delay="300" style="background-color: #032d57;">
                <div style="margin:10%;" class="white_fonts">
                    <h3>
                        <strong>Online Training</strong>
                    </h3>
                    <p class="theme_color fontSize">
                        SFI safety, Inc. has partnered with Red Vector to provide online safety training. Red
                        Vector
                        is an OSHA authorized online training provider. This partnership allows us to provide
                        quality
                        online training for those who cannot make it to a live class.
                    </p>
                    <a class="btn" style="background-color: #962824;color: white;"
                    href="https://business.clicksafety.com/sficompliance/" target="_blank">
                        Learn More
                    </a>
                </div>

            </div>

            
        </div>
        <div class="row">
            <div class="col-lg-12">
                <div class="row" style="padding-top: 3%;">
                    <div class="col-lg-4" data-aos="fade-right" data-aos-delay="300" style="padding-top: 20px;">
                        <img src="../../assets/images/training room.JPG" class="img-fluid" alt="" /><br />
                    </div>
                    <div class="col-lg-8" data-aos="fade-left" data-aos-delay="300" style="padding-top: 20px;">
                        <h1 class="theme_color">
                            <strong>We also offer room rentals!</strong>.
                        </h1>
    
                        <p class="theme_color fontSize">Need a space for your next corporate meeting? We offer our
                            training room for rent hourly or for the day. <strong><a href="/contact"
                                    class="theme_color"><u>Contact us</u></a></strong> for more information or to get a
                            quote!</p>
    
                        <p>Email us at <a
                                href="mailto:customerservice@sfisafety.com">customerservice@sfisafety.com</a>
                            to schedule your next training today!</p>
    
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>